"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const webjs_sdk_1 = require("@aria/webjs-sdk");
const bew_localization_1 = require("@skype/bew-localization");
const react_1 = require("@stardust-ui/react");
const config_1 = require("config");
const lodash_1 = require("lodash");
const React = require("react");
const SyncTasks = require("synctasks");
require("../../vendor/silentLogin");
const RootView_1 = require("./components/bots/RootView");
const AriaLive_1 = require("./components/common/AriaLive");
const ErrorBoundary_1 = require("./components/common/ErrorBoundary");
const ErrorDetails_1 = require("./components/common/ErrorDetails");
const RootView_2 = require("./components/do/RootView");
const RootView_3 = require("./components/invites/RootView");
const RootView_4 = require("./components/meetings/RootView");
const RootView_5 = require("./components/profiles/RootView");
const AriaContext_1 = require("./contexts/AriaContext");
const ConfigContext_1 = require("./contexts/ConfigContext");
const ErrorContext_1 = require("./contexts/ErrorContext");
const UserContext_1 = require("./contexts/UserContext");
const CookieHelper_1 = require("./helpers/CookieHelper");
const EnvironmentHelper_1 = require("./helpers/EnvironmentHelper");
const LoggerHelper_1 = require("./helpers/LoggerHelper");
const SharedTypes_1 = require("./models/SharedTypes");
const ProfileRestClient_1 = require("./rest/ProfileRestClient");
const localThemes = require("./themes");
var EntryPoint;
(function (EntryPoint) {
    EntryPoint["Meetings"] = "meetings";
    EntryPoint["Invites"] = "invites";
    EntryPoint["Bots"] = "bots";
    EntryPoint["Do"] = "do";
    EntryPoint["Profiles"] = "profiles";
})(EntryPoint = exports.EntryPoint || (exports.EntryPoint = {}));
class App extends React.Component {
    constructor(props) {
        super(props);
        this._switchLanguage = (language) => {
            CookieHelper_1.CookieHelper.setCookieValue(this.state.configContext.cookies.skype, language, 'LC');
            window.location.reload(true);
        };
        this._announce = (message) => {
            this.setState((prevState) => {
                const { ariaContext } = prevState;
                ariaContext.message = message;
                return { ariaContext };
            });
        };
        this._setErrorContext = (error) => {
            this.setState((prevState) => {
                const { errorContext } = prevState;
                errorContext.error = error;
                return {
                    errorContext,
                };
            });
        };
        this._clearErrorContext = () => {
            this.setState((prevState) => {
                const { errorContext } = prevState;
                errorContext.error = undefined;
                return {
                    errorContext,
                };
            });
        };
        this._getProfileAsync = (loginResult) => {
            if (!loginResult || !loginResult.skypetoken) {
                return SyncTasks.Resolved({
                    profile: undefined,
                    skypetoken: undefined,
                    expiration: undefined,
                    isLoginInProgress: false,
                });
            }
            return ProfileRestClient_1.default.getUserProfileInfo(loginResult.skypetoken)
                .then((profile) => {
                const userContext = {
                    profile,
                    skypetoken: loginResult.skypetoken,
                    expiration: loginResult.expiration,
                    isLoginInProgress: false,
                };
                LoggerHelper_1.logger.initCommonProperty({ key: LoggerHelper_1.CommonProperty.SkypeId, value: profile.username, piiKind: webjs_sdk_1.AWTPiiKind.Identity });
                return userContext;
            });
        };
        this._loadTranslation = () => {
            bew_localization_1.localizer.initSync({
                locale: this.props.language,
                localizedTable: window.I18NBUNDLE,
                fallback: 'en',
                fallbackTable: window.I18NBUNDLE_FALLBACK || window.I18NBUNDLE,
            });
        };
        this.state = {
            loadingTranslations: true,
            configContext: {
                ...config_1.default,
                basePath: this.props.basePath,
                language: props.language,
                switchLanguage: this._switchLanguage,
            },
            theme: lodash_1.merge({}, localThemes.common, props.theme === SharedTypes_1.Themes.Teams ? localThemes.teams : localThemes.light),
            userContext: {
                skypetoken: undefined,
                expiration: undefined,
                profile: undefined,
                isLoginInProgress: this._canUseSilentLogin(),
            },
            errorContext: {
                error: undefined,
                setError: this._setErrorContext,
                clear: this._clearErrorContext,
            },
            ariaContext: {
                message: { assertive: false, text: '' },
                announce: this._announce,
            },
        };
        LoggerHelper_1.logger.initCommonProperty({ key: LoggerHelper_1.CommonProperty.EntryPoint, value: props.entryPoint });
    }
    componentDidMount() {
        // Injecting browser specific styles in <head>
        const style = document.createElement('style');
        if (EnvironmentHelper_1.browser === EnvironmentHelper_1.Browsers.Safari && EnvironmentHelper_1.deviceType === EnvironmentHelper_1.DeviceTypes.Mobile && document.head) {
            style.innerHTML = `.meetings .ui-button, .bots .ui-button, .invites .ui-button { display: block; }`;
            document.head.appendChild(style);
        }
        this._loadTranslation();
        this.setState({ loadingTranslations: false });
        if (this._canUseSilentLogin()) {
            this._silentLoginAsync()
                .then(this._getProfileAsync)
                .then((userContext) => this.setState({ userContext }))
                .catch(() => {
                this.setState({
                    userContext: {
                        profile: undefined,
                        skypetoken: undefined,
                        expiration: undefined,
                        isLoginInProgress: false,
                    },
                });
            }); // it's ok if the user is not logged in
        }
    }
    render() {
        return React.createElement(React.Fragment, null,
            !this.state.loadingTranslations && React.createElement("a", { tabIndex: -1, className: 'hidden', href: `#${SharedTypes_1.mainContentId}` }, bew_localization_1.localizer.getString('Common.a11y_lnk_skip_content')),
            React.createElement(react_1.Provider, { theme: { ...react_1.themes.teams, siteVariables: { ...react_1.themes.teams.siteVariables, htmlFontSize: '16px' } } },
                React.createElement(react_1.Provider, { theme: this.state.theme },
                    React.createElement(ConfigContext_1.ConfigContextProvider, { value: this.state.configContext },
                        React.createElement(UserContext_1.UserContextProvider, { value: this.state.userContext },
                            React.createElement(ErrorBoundary_1.ErrorBoundary, null,
                                React.createElement(ErrorContext_1.ErrorContextProvider, { value: this.state.errorContext },
                                    React.createElement(AriaContext_1.AriaContextProvider, { value: this.state.ariaContext },
                                        React.createElement(AriaLive_1.AriaLive, null),
                                        this._getRootView(),
                                        this._renderErrorPortal()))))))));
    }
    _renderErrorPortal() {
        const error = this.state.errorContext && this.state.errorContext.error;
        if (!error) {
            return;
        }
        return React.createElement(react_1.Portal, { trapFocus: {
                isClickableOutsideFocusTrap: false,
            }, open: !!error, content: this._renderErrorPortalContent(error), as: lodash_1.noop });
    }
    _renderErrorPortalContent(error) {
        return React.createElement("div", { className: 'portalContainer', role: 'dialog', "aria-modal": 'true' },
            React.createElement("div", { className: 'portalContent' },
                React.createElement(ErrorDetails_1.ErrorDetails, { error: error }),
                React.createElement(react_1.Button, { content: bew_localization_1.localizer.getString('Common.btn_close'), className: 'closeButton', onClick: this.state.errorContext && this.state.errorContext.clear })));
    }
    _canUseSilentLogin() {
        return this.props.entryPoint !== EntryPoint.Bots;
    }
    _getRootView() {
        switch (this.props.entryPoint) {
            case EntryPoint.Meetings:
                return React.createElement(RootView_4.RootView, { loading: this.state.loadingTranslations, userContext: this.state.userContext });
            case EntryPoint.Invites:
                return React.createElement(RootView_3.RootView, { loading: this.state.loadingTranslations });
            case EntryPoint.Bots:
                return React.createElement(RootView_1.RootView, { loading: this.state.loadingTranslations, skypetoken: this.props.skypetoken });
            case EntryPoint.Do:
                return React.createElement(RootView_2.RootView, { loading: this.state.loadingTranslations });
            case EntryPoint.Profiles:
                return React.createElement(RootView_5.RootView, { loading: this.state.loadingTranslations });
        }
    }
    _silentLoginAsync() {
        const initLogin = () => {
            const silentLogin = window.SKYPE.login.Silent;
            const deferral = SyncTasks.Defer();
            silentLogin.init(config_1.default.silentLogin)
                .setCallback((response) => {
                if (response && response.skypetoken) {
                    deferral.resolve({ skypetoken: response.skypetoken, expiration: response.expires_in });
                    return;
                }
                if (response && response.error) {
                    deferral.reject({ error: response.error, errorDescription: response.error_description || '' });
                    return;
                }
                deferral.reject();
            })
                .load();
            return deferral.promise();
        };
        const startTime = new Date().getTime();
        return initLogin()
            .done(() => LoggerHelper_1.logger.silentLogin({ status: LoggerHelper_1.SilentLoginStatus.Success, duration: new Date().getTime() - startTime }))
            .fail((response) => LoggerHelper_1.logger.silentLogin({
            status: LoggerHelper_1.SilentLoginStatus.Fail,
            duration: new Date().getTime() - startTime,
            error: response.error,
            errorDescription: response.errorDescription,
        }));
    }
}
exports.App = App;
